import { type CatalogQuery, getCatalog } from '@/lib/api/reports-client.js';
import type { CatalogResponse } from '@/lib/api/types.js';
import { useQuery } from '@tanstack/react-query';

export function useCatalog(params: CatalogQuery) {
  return useQuery<CatalogResponse, Error>({
    queryKey: ['catalog', params],
    queryFn: () => getCatalog(params),
    staleTime: 30_000,
  });
}
